module.exports = __webpack_public_path__ + "static/monitaur-390-aa5a6a4521d1b7c2d4c173ea62d5bb54.png";